import { navigateToView } from './routing.js';
import { MailIcon } from '../icons.js';

const CONTACT_EMAIL = 'hello@aslgo.com';

const HEADING = {
  learner: 'Check your email',
  guide: 'Thank you for applying as a Deaf Guide!',
} as const;

const NEXT_STEP = {
  learner: 'Once confirmed, sign back in and you can start booking sessions with a Deaf guide.',
  guide: "Once confirmed, sign back in and you'll be prompted to upload your introduction video — the next step in your application.",
} as const;

export function RegistrationComplete({ email, role }: { email: string; role: 'learner' | 'guide' }) {
  return (
    <div className="max-w-md mx-auto card p-7 lg:p-10 has-grain animate-fade-up text-center">
      <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-brand-subtle dark:bg-brand-bright/15">
        <MailIcon width={32} height={32} className="text-ink-900 dark:text-brand-bright" />
      </div>

      <h2 className="h-card mb-3 text-ink-900 dark:text-ink-100">{HEADING[role]}</h2>

      <p className="hint mb-4">
        We sent a confirmation link to{' '}
        <span className="font-medium text-ink-900 dark:text-ink-100 break-words">{email}</span>.
      </p>

      <p className="hint mb-3">
        Check your email to confirm your account. If it is not in your inbox, check your
        spam folder. If it does not arrive within 15 minutes, contact{' '}
        <a className="underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>

      <p className="hint mb-6">{NEXT_STEP[role]}</p>

      <button
        type="button"
        className="btn-primary w-full justify-center"
        onClick={() => { window.history.pushState({}, '', '/'); navigateToView('login'); }}
      >
        Go to Sign In
      </button>
    </div>
  );
}
